import clsx from 'clsx';
import React, { createContext, useContext } from 'react';
var Context = createContext(null);
export var useVisualContext = function () {
    return useContext(Context);
};
export default function VisualContext(_a) {
    var contextName = _a.contextName, className = _a.className, children = _a.children;
    return (React.createElement(Context.Provider, { value: contextName },
        React.createElement("div", { className: clsx("awsui-context-" + contextName, className) }, children)));
}
//# sourceMappingURL=index.js.map